import { MoveHorizontal } from 'lucide-react'

/**
 * Phone-only cue above a horizontally scrolling table (FRIDGE-1031, the
 * owner's "phone tables" row, 09/17/2026).
 *
 * The wide tables on /rebates, /filters/cross-reference, /data/most-efficient
 * and the brand filter pages were already real scroll containers
 * (`overflow-x-auto`, measured scrollable at 390 px with Playwright) — the
 * defect was that nothing told a phone reader the hidden columns exist, so
 * the table read as cut off. This line says so, and disappears from `sm` up
 * where the table fits. Purely visual: the wrapper's `role="region"` and
 * `aria-label` remain the assistive-technology contract.
 */
export function TableScrollHint({ className = '' }: { className?: string }) {
  return (
    <p
      className={`sm:hidden flex items-center gap-1.5 text-[12px] font-medium text-gray-500 mb-2 ${className}`}
      data-table-scroll-hint=""
      aria-hidden="true"
    >
      <MoveHorizontal className="w-3.5 h-3.5 shrink-0" strokeWidth={2} />
      Swipe sideways to see every column
    </p>
  )
}
